/** Em dev, localhost:8000 equivale a usar o proxy do Vite (`/api` → 8000). */
function shouldUseRelativeApiInDev(trimmed: string): boolean {
  if (!import.meta.env.DEV) return false;
  return /^https?:\/\/(127\.0\.0\.1|localhost):8000\/?$/i.test(trimmed);
}

/** Host explícito da API (sem barra final). Vazio = pedidos relativos ao origin (Vite proxy em dev; reverse proxy em prod). */
export function getApiOrigin(): string {
  const v = import.meta.env.VITE_API_URL;
  if (v == null || String(v).trim() === '') {
    return '';
  }
  const trimmed = String(v).replace(/\/+$/, '');
  if (shouldUseRelativeApiInDev(trimmed)) {
    return '';
  }
  return trimmed;
}

/**
 * Origin do Django para rotas fora de `/api` (ex.: `/admin/`). Com API relativa, em dev usa localhost:8000.
 */
export function getBackendDirectOrigin(): string {
  const explicit = getApiOrigin();
  if (explicit) {
    return explicit;
  }
  if (import.meta.env.DEV) {
    return 'http://localhost:8000';
  }
  return '';
}

// Environment Configuration
export const ENV_CONFIG = {
  get API_URL(): string {
    return getApiOrigin();
  },
  GEMINI_API_KEY: import.meta.env.VITE_GEMINI_API_KEY || '',
};

// Development mode check
export const IS_DEVELOPMENT = import.meta.env.DEV;
export const IS_PRODUCTION = import.meta.env.PROD;
